import { AxiosPromise } from 'axios'

import api from '@config/api'

export function getBudgetReport(data: any): AxiosPromise {
  return api.post('v1/OrcamentoRelatorio', data, {})
}

export function postExportConsolidated(data: any): AxiosPromise {
  return api.post('v1/OrcamentoRelatorio/Consolidado/Exportar', data, {})
}

export function postExportAnalitc(data: any): AxiosPromise {
  return api.post('v1/OrcamentoRelatorio/Analitico/Exportar', data, {})
}
export function getBudgetCommercial(data: any): AxiosPromise {
  return api.post('v1/OrcamentoComercial', data, {})
}

export function getBudgetConciliation(data: any): AxiosPromise {
  return api.post('v1/OrcamentoConciliacao', data, {})
}

export function getBudgetStore(data: any): AxiosPromise {
  return api.post('v1/OrcamentoLoja', data, {})
}

export function getBudgetParameters(): AxiosPromise {
  return api.get('v1/OrcamentoParametro/BTLeo')
}
export function putBudgetParameters(data: any): AxiosPromise {
  return api.put('v1/OrcamentoParametro/BTLeo', data, {})
}
export function postExportCommercialConsolidated(data: any): AxiosPromise {
  return api.post('v1/OrcamentoComercial/Consolidado/Exportar', data, {})
}

export function postExportCommercialAnalitc(data: any): AxiosPromise {
  return api.post('v1/OrcamentoComercial/Analitico/Exportar', data, {})
}

export function postExportStoreConsolidated(data: any): AxiosPromise {
  return api.post('v1/OrcamentoLoja/Consolidado/Exportar', data, {})
}

export function postExportStoreAnalityc(data: any): AxiosPromise {
  return api.post('v1/OrcamentoLoja/Analitico/Exportar', data, {})
}

export function postExportConciliationConsolidated(data: any): AxiosPromise {
  return api.post('v1/OrcamentoConciliacao/Consolidado/Exportar', data, {})
}

export function postExportConciliationAnalityc(data: any): AxiosPromise {
  return api.post('v1/OrcamentoConciliacao/Analitico/Exportar', data, {})
}

///
export function updateBtLeoParameter(data: any): AxiosPromise {
  return api.put('v1/OrcamentoParametro/BtLeo', data, {})
}

export function getMargemMediaParameter(): AxiosPromise {
  return api.get('v1/OrcamentoParametro/MargemMedia')
}

export function putMargemMediaParameter(data: any): AxiosPromise {
  return api.put('v1/OrcamentoParametro/MargemMedia', data, {})
}

export function postUpdateBaseBudget(): AxiosPromise {
  return api.put(
    'v1/OrcamentoParametro/Atualizar/BaseOrcamento',
    {
      modulo: 'FULL'
    },
    {}
  )
}

export function putCommercialBudget(data: any): AxiosPromise {
  return api.put('v1/OrcamentoComercial', data, {})
}

export function putStoreBudget(data: any): AxiosPromise {
  return api.put('v1/OrcamentoLojas', data, {})
}

export function putConciliationBudget(data: any): AxiosPromise {
  return api.put('v1/OrcamentoConciliacao', data, {})
}
export default {
  getBudgetReport,
  postExportConsolidated,
  getBudgetCommercial,
  postExportAnalitc,
  getBudgetConciliation,
  getBudgetStore,
  postExportCommercialConsolidated,
  updateBtLeoParameter,
  putMargemMediaParameter,
  putBudgetParameters,
  postExportStoreAnalityc,
  postExportStoreConsolidated,
  postExportConciliationConsolidated,
  postExportCommercialAnalitc,
  postExportConciliationAnalityc,
  putCommercialBudget,
  getMargemMediaParameter,
  putStoreBudget,
  putConciliationBudget,
  postUpdateBaseBudget,
  getBudgetParameters
}
